import FormControl from './FormControl';
import FormGroup from './FormGroup';
import FormArray from './FormArray';

export default class FormBuilder {
  constructor(defaultValue) {
    this.controls = {};
    this.defaultValue = defaultValue;
  }

  createControl(name, validators) {
    this.controls[name] = new FormControl(this.defaultValue[name], validators);

    return this;
  }

  createGroup(name, controls) {
    this.controls[name] = new FormGroup(controls, []);

    return this;
  }

  createArray(name, controls, validators) {
    this.controls[name] = new FormArray(controls, [], validators);

    return this;
  }

  build(validationStrategy) {
    return new FormGroup(this.controls, validationStrategy);
  }
}
